import { render } from "./profile-form.vue?vue&type=template&id=57da1c3b"
import script from "./profile-form.vue?vue&type=script&lang=js"
export * from "./profile-form.vue?vue&type=script&lang=js"

import "./profile-form.vue?vue&type=style&index=0&id=57da1c3b&lang=css"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__